import { useEffect, useRef } from "react";

/** Asks for the next page as the end of the list scrolls into view. */
export function LoadMoreSentinel({ onVisible, loading }: { onVisible: () => void; loading: boolean }) {
  const ref = useRef<HTMLDivElement>(null);
  const callback = useRef(onVisible);
  callback.current = onVisible;

  // Observed afresh after each page: a sentinel still on screen when the page lands fires again.
  useEffect(() => {
    const node = ref.current;
    if (loading || !node || typeof IntersectionObserver === "undefined") return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) callback.current();
      },
      { rootMargin: "400px 0px" },
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [loading]);

  return (
    <div ref={ref} className="flex justify-center py-4">
      {loading ? (
        <div className="h-5 w-5 animate-spin rounded-full border-2 border-line border-t-accent" role="status" />
      ) : (
        <button type="button" onClick={onVisible} className="btn-ghost">
          Load more
        </button>
      )}
    </div>
  );
}
